var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3606 47.7179L17.15 47.4779L16.8801 47.2978L16.55 47.1779L16.3401 47.1478H16.16C15.7995 47.2677 15.4401 47.3783 15.0794 47.4779C14.6995 47.6177 14.3294 47.6081 13.9694 47.4478C13.6497 47.2876 13.3796 47.0079 13.1595 46.6083L13.1895 46.6378C13.0497 46.4183 12.979 46.1482 12.979 45.8279C12.979 45.5878 13.0097 45.3582 13.069 45.1378L13.3991 44.1484C13.4188 44.1081 13.4188 44.038 13.3991 43.9378L13.2792 43.4583C13.2192 43.3179 13.1694 43.2273 13.1292 43.1878L12.6802 43.248C12.2001 43.3085 11.9505 43.3374 11.9302 43.3374C11.77 43.3572 11.4903 43.3482 11.0907 43.308C10.7511 43.2677 10.4806 43.2072 10.2802 43.1273L9.83016 42.9773L9.68016 42.8872L9.20008 43.9978C8.56043 45.4575 8.03973 46.6775 7.64013 47.6583L7.67021 47.7777V47.8083L7.73017 47.8378H7.85009L8.78019 47.7484C9.40049 47.7081 9.87044 47.7281 10.1907 47.8089C10.771 47.9685 11.2011 48.1888 11.4802 48.4689C11.7802 48.7886 11.9505 49.1685 11.9907 49.6089V50.4484C11.9511 50.788 11.9404 51.0484 11.9607 51.2285C12.2204 51.1091 12.4906 50.9986 12.7706 50.8984L14.6306 50.1484C15.731 49.7085 16.3706 49.4679 16.5505 49.4285L17.6905 49.0385V49.009C17.6102 48.3877 17.5004 47.9585 17.3606 47.7179ZM23.2401 41.4479C23.36 41.7276 23.4202 41.9981 23.4202 42.2584C23.4202 42.4774 23.3397 42.8782 23.1801 43.4584C23.0608 43.8778 22.9905 44.1479 22.9702 44.2684C22.9504 44.5084 22.9702 44.7077 23.0301 44.8684C23.0504 44.968 23.1002 45.058 23.1801 45.1377L23.3301 45.3483C23.5108 45.5481 23.8502 45.7088 24.35 45.8284C24.9897 45.9885 25.3305 46.078 25.3699 46.0983C25.55 46.1588 25.7096 46.228 25.85 46.3088L26.3606 46.1282C26.4205 46.1084 26.9 45.9584 27.8 45.6782C28.3401 45.518 28.7301 45.3782 28.9699 45.2588C29.1894 45.1184 29.3197 45.008 29.36 44.9282V44.7182L29.24 44.3282L29 43.8782C28.8801 43.6981 28.7701 43.568 28.6699 43.4881C28.4096 43.1684 28.1504 42.8881 27.8898 42.6487C27.5093 42.3084 26.9394 41.8381 26.1793 41.2381L22.9099 38.7487C21.5701 37.7682 20.6498 37.0686 20.1494 36.6487C19.4498 36.0487 18.7892 35.3592 18.1693 34.5788C16.4292 32.2387 15.2593 30.5989 14.6593 29.6594L14.1488 28.7594L14.9593 29.4489C15.8593 30.3086 17.2394 31.7684 19.0988 33.829C19.8789 34.6096 20.549 35.1891 21.1093 35.569C21.5286 35.869 22.4695 36.4888 23.9287 37.429L27.3486 39.7389C28.2882 40.3995 28.9386 40.8993 29.2986 41.2389C29.5386 41.4196 29.8788 41.7393 30.3185 42.1995C30.7786 42.7792 31.0685 43.2194 31.1884 43.5194C31.3485 43.8993 31.4487 44.1993 31.4884 44.4194L31.5184 44.9594C31.5382 45.0393 31.5184 45.2391 31.4585 45.5594L31.2184 46.1288L30.8284 46.6094C30.5889 46.8489 30.3088 47.0594 29.9889 47.2389C29.569 47.459 29.0588 47.6692 28.4588 47.8696C27.5186 48.1696 27.0284 48.3292 26.9889 48.3497L13.7589 53.3892C11.9787 54.0894 10.5886 54.5694 9.58905 54.8292C8.6086 55.0693 7.78905 55.1993 7.1285 55.2193C6.5488 55.2193 6.0287 55.1491 5.56855 55.0093C5.24882 54.9085 4.9488 54.7585 4.66855 54.5593L4.24863 54.1987L3.88867 53.7487C3.70859 53.3882 3.58867 53.0185 3.52812 52.6382L3.5 51.7679L3.74004 50.3579C3.92012 49.5773 4.17989 48.7374 4.52014 47.8374C4.94006 46.7376 5.63009 45.0876 6.59004 42.8874L10.25 32.0274C10.4101 31.5673 10.8002 30.6972 11.4199 29.4175C11.6802 28.8571 11.88 28.4671 12.0199 28.2476C12.2197 27.9273 12.4699 27.737 12.7699 27.6777C13.0699 27.6183 13.3302 27.8175 13.55 28.2777C13.7301 28.7379 13.79 29.3079 13.7301 29.9876C13.6904 30.5277 13.5801 31.1277 13.4 31.7876C13.3803 31.8273 13.2398 32.2376 12.9801 33.0183C12.9603 33.038 12.8607 33.3279 12.6801 33.8876L12.8 34.0082C13.0004 34.1474 13.2398 34.2578 13.5199 34.3376C13.9201 34.4781 14.58 34.6574 15.5 34.8777C16.4396 35.158 17.1002 35.6079 17.4801 36.2277C17.7801 36.7084 17.9504 37.4277 17.9906 38.3876C17.9906 39.1484 18.0207 39.638 18.0801 39.8581C18.1803 40.1779 18.3902 40.4078 18.7107 40.5476C18.8104 40.6081 18.9303 40.6371 19.0707 40.6371L19.6406 40.5476C20.5406 40.3478 21.0207 40.2476 21.0801 40.2476C21.4605 40.2476 21.7502 40.2777 21.95 40.3371L22.3699 40.5177L22.7298 40.7871C22.9501 40.9679 23.12 41.1875 23.2401 41.4479Z",
    fill: "url(#paint0_linear_563_19809)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0279 5.44683C51.6677 6.40758 50.1984 7.71678 48.6179 9.37693C47.7179 10.3363 46.5983 11.6071 45.2579 13.187C42.7775 16.0478 40.9877 18.0068 39.8879 19.0675C38.8474 20.0474 37.4375 21.3974 35.6578 23.1175L34.0379 24.7675L32.8978 26.2369C31.8574 27.6775 31.0877 28.6873 30.5879 29.2675C30.3281 29.5675 30.1877 29.757 30.168 29.8369H30.2879C30.4275 29.817 30.6177 29.757 30.8578 29.6574C31.6576 29.2566 32.6972 28.4465 33.9771 27.2267L36.947 24.6168C38.0072 23.7967 39.5269 22.5469 41.5076 20.8668C42.9669 19.647 44.9073 17.6863 47.3271 14.9863C49.3474 12.7867 50.4573 11.5867 50.6577 11.3863C52.2773 9.76674 53.6374 8.55598 54.7378 7.75678C55.0378 7.53648 55.3275 7.22574 55.6077 6.82613C55.9876 6.30598 56.0482 5.81635 55.7878 5.35678C55.5081 4.87669 55.0282 4.69681 54.3478 4.81673C54.0281 4.87693 53.5882 5.08629 53.0279 5.44683Z",
    fill: "url(#paint1_linear_563_19809)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4284 32.2676C31.5286 32.0869 31.5888 31.9369 31.6091 31.8176L31.5786 31.6678C31.4591 31.5873 31.2485 31.5772 30.9485 31.6371C30.0089 31.877 29.0788 32.3174 28.1591 32.9576C27.9987 33.0373 28.0888 33.3068 28.4284 33.7676C28.7692 34.2074 28.9888 34.3771 29.089 34.2775C30.4485 33.3373 31.2286 32.6672 31.4284 32.2676Z",
    fill: "url(#paint2_linear_563_19809)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.739 29.7173C33.6189 29.7775 33.7089 30.0372 34.0089 30.4974C34.3486 30.9373 34.5484 31.1273 34.6097 31.0667C35.4894 30.5466 36.0497 30.0468 36.2898 29.5667C36.3695 29.4263 36.4097 29.2966 36.4097 29.1767L36.379 29.0573C36.2994 28.9566 36.1294 28.9073 35.8691 28.9073C35.3085 28.9073 34.5993 29.1772 33.739 29.7173Z",
    fill: "url(#paint3_linear_563_19809)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9493 26.1472C43.0698 25.9671 43.1395 25.8171 43.1598 25.6972L43.1596 25.5472C43.0594 25.447 42.8387 25.4267 42.499 25.4866C42.3994 25.5064 42.049 25.6072 41.449 25.7866L39.5891 26.6866C39.4295 26.7669 39.4889 27.037 39.7692 27.4972C40.0495 27.937 40.2594 28.1171 40.3993 28.0366C41.8393 27.2577 42.6889 26.6273 42.9493 26.1472Z",
    fill: "url(#paint4_linear_563_19809)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5695 23.3269V23.1769C47.5101 23.0576 47.3896 22.9765 47.2095 22.9371C46.6894 22.8375 46.0894 23.0269 45.4095 23.5076C45.3496 23.567 45.4695 23.8076 45.7695 24.2269C46.0695 24.6265 46.2693 24.8269 46.3695 24.8269C47.0097 24.3474 47.3798 23.9672 47.4794 23.6869C47.5394 23.567 47.5695 23.4468 47.5695 23.3269Z",
    fill: "url(#paint5_linear_563_19809)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7692 34.2774C33.8495 34.7778 33.9888 35.0274 34.1892 35.0274C35.5691 34.7473 36.5993 34.3674 37.2792 33.8866C37.4593 33.7473 37.5888 33.617 37.6693 33.4971L37.6993 33.3772C37.6391 33.2375 37.4292 33.1475 37.0692 33.1079C36.5089 33.0071 35.4392 33.1176 33.8593 33.4373C33.6792 33.4373 33.6493 33.717 33.7692 34.2774Z",
    fill: "url(#paint6_linear_563_19809)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8088 33.6173C42.269 33.5973 42.719 33.5368 43.1588 33.4366C43.4588 33.3971 43.7985 33.3173 44.1784 33.1972L44.8983 32.9272L45.3486 32.627C45.549 32.4874 45.6781 32.347 45.7387 32.2077L45.7688 32.0577C45.6885 31.9366 45.4688 31.8669 45.1088 31.8472L41.6588 31.9972C41.4784 32.0974 41.4086 32.377 41.4483 32.8366C41.4885 33.3569 41.6084 33.6173 41.8088 33.6173Z",
    fill: "url(#paint7_linear_563_19809)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0089 31.0084C51.9681 30.8879 51.8085 30.7883 51.5282 30.7084C50.9683 30.5476 50.0882 30.5871 48.8888 30.8285C48.7688 30.8879 48.7688 31.1681 48.8888 31.6685C48.9884 32.1683 49.1181 32.4185 49.2782 32.4185C50.4585 32.158 51.269 31.8484 51.7089 31.4879C51.8485 31.3683 51.9386 31.258 51.9782 31.1584L52.0089 31.0084Z",
    fill: "url(#paint8_linear_563_19809)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1093 29.5077C56.5093 29.3073 55.7888 29.3577 54.9488 29.6577C54.8289 29.7171 54.8593 29.9974 55.0386 30.498C55.179 30.9778 55.299 31.2179 55.3986 31.2179C56.3791 30.8782 56.9892 30.5782 57.2287 30.3179C57.3488 30.1977 57.4291 30.0874 57.4687 29.9872L57.4988 29.8372C57.4591 29.6974 57.3289 29.5876 57.1093 29.5077Z",
    fill: "url(#paint9_linear_563_19809)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3293 39.6175C29.5297 39.8972 29.8692 40.1772 30.3492 40.4575L30.7999 40.6669L31.1899 40.7569C31.5295 40.8366 31.8596 40.8565 32.1793 40.8169C32.4794 40.7575 32.6594 40.6669 32.7194 40.547C32.7391 40.4065 32.6389 40.2368 32.4194 40.0364L31.6995 39.497C31.1391 39.137 30.7893 38.8567 30.6495 38.6575C30.6092 38.6173 30.3495 38.7175 29.8694 38.9575C29.4098 39.2173 29.2297 39.4368 29.3293 39.6175Z",
    fill: "url(#paint10_linear_563_19809)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0091 42.3472C36.769 41.9865 36.2188 41.6271 35.3591 41.2671C35.2187 41.2671 35.079 41.5078 34.9392 41.9865C34.7593 42.5068 34.7191 42.7672 34.8193 42.7672C35.6388 43.0875 36.279 43.207 36.7392 43.1271C36.9784 43.0677 37.1189 42.9771 37.1591 42.8578C37.1987 42.7168 37.1489 42.547 37.0091 42.3472Z",
    fill: "url(#paint11_linear_563_19809)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5491 45.8865C40.7286 45.8271 40.8586 45.7365 40.9391 45.6172C40.9793 45.4767 40.9794 45.3268 40.9391 45.1668C40.9194 45.0258 40.8294 44.8668 40.6692 44.6861L40.3391 44.4467C40.1993 44.3465 40.0192 44.2672 39.7991 44.2072C39.7194 44.2072 39.6294 44.4568 39.5292 44.9572C39.4098 45.4168 39.3594 45.6867 39.3792 45.7672C39.8993 45.9262 40.2887 45.967 40.5491 45.8865Z",
    fill: "url(#paint12_linear_563_19809)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4479 38.4764C46.0678 38.2364 45.0677 38.0569 44.4479 37.9364L39.7078 37.0676C38.2672 36.8078 37.0973 36.6272 36.1973 36.5275L33.7973 36.1975C32.7377 36.0576 31.9576 36.0072 31.4578 36.0475L31.0078 36.1369L31.3078 36.4676C31.7074 36.7875 32.4076 37.1672 33.4078 37.6076L39.1678 39.4371C40.2876 39.7569 40.9979 39.9471 41.2979 40.0076L43.9085 40.667C44.5284 40.8063 45.5081 41.0067 46.8479 41.267C48.0085 41.5268 49.0183 41.8167 49.878 42.1364C50.6179 42.4164 51.2179 42.1561 51.678 41.3569C51.9583 40.8967 51.9583 40.4569 51.678 40.0364C51.4782 39.7364 51.228 39.5366 50.928 39.4364C49.8479 39.0567 48.6876 38.7368 47.4479 38.4764Z",
    fill: "url(#paint13_linear_563_19809)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4482 25.3678C29.4285 25.1471 29.3787 24.9772 29.2982 24.8579L29.2084 24.7678L29.0584 24.8278C28.9383 24.8879 28.8082 24.9977 28.6684 25.1584L28.0383 26.0584C27.5182 26.9176 27.1684 27.5585 26.9883 27.9778C26.9883 28.1782 27.2084 28.3571 27.6482 28.5178C28.0881 28.6973 28.3684 28.7272 28.4883 28.6079C29.2287 26.9674 29.5484 25.8874 29.4482 25.3678Z",
    fill: "url(#paint14_linear_563_19809)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0273 19.3357C32.0076 19.1359 31.9679 18.9859 31.908 18.8857L31.8171 18.7656C31.7974 18.7656 31.7578 18.7753 31.6972 18.7956C31.5773 18.8351 31.4374 18.9251 31.2773 19.0656C30.8577 19.4652 30.3773 20.3258 29.8378 21.6457C29.7575 21.806 29.9878 21.9656 30.5273 22.1257C31.0277 22.3062 31.3074 22.3261 31.3673 22.1857C31.8671 20.8861 32.0878 19.9357 32.0273 19.3357Z",
    fill: "url(#paint15_linear_563_19809)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6685 13.9064C34.6488 13.7259 34.599 13.586 34.5185 13.4859L34.4284 13.4247C34.3888 13.4247 34.339 13.4351 34.2784 13.4554C34.1589 13.4753 34.0288 13.5353 33.889 13.6349L33.649 13.8454L33.3189 14.2349L32.749 15.1954L32.539 15.706C32.4587 15.8656 32.689 16.0156 33.2285 16.156C33.7882 16.2958 34.0685 16.3156 34.0685 16.216L34.2185 15.8259L34.6685 14.2958V13.9064Z",
    fill: "url(#paint16_linear_563_19809)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4984 7.1576C36.4787 7.13729 36.439 7.13729 36.3785 7.1576C36.259 7.17732 36.1185 7.24705 35.9592 7.36776C35.4389 7.80686 35.0285 8.64746 34.7285 9.88711C34.7285 10.0473 34.9683 10.1871 35.4484 10.3076C36.0082 10.427 36.2885 10.4168 36.2885 10.277C36.5685 9.17655 36.7084 8.3166 36.7084 7.69685C36.6881 7.51697 36.6484 7.37654 36.5885 7.27693L36.4984 7.1576Z",
    fill: "url(#paint17_linear_563_19809)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5287 30.1079C21.8287 29.6669 21.9393 29.4071 21.8594 29.3272C21.3992 28.8474 21.0685 28.5071 20.8687 28.3071C20.609 28.0071 20.369 27.817 20.1488 27.7366C19.9688 27.6569 19.8188 27.6172 19.6988 27.6172L19.5494 27.6479L19.4895 27.7678C19.4492 27.8674 19.4391 27.9971 19.4594 28.1578C19.4988 28.4375 19.5889 28.7375 19.7287 29.0578C19.9694 29.6578 20.3389 30.168 20.8393 30.5873C20.9988 30.6676 21.2287 30.5075 21.5287 30.1079Z",
    fill: "url(#paint18_linear_563_19809)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3493 25.1571L17.8993 24.4071C17.6995 24.1665 17.5392 24.0063 17.4193 23.9264L17.0293 23.6571L16.6693 23.5071C16.5289 23.4668 16.409 23.4668 16.3094 23.5071L16.1894 23.567L16.1289 23.717C16.1092 23.8366 16.1193 23.9666 16.1596 24.1071L16.249 24.4071C16.3096 24.6063 16.3594 24.7274 16.399 24.767L16.9391 25.9071C16.9391 26.027 17.1996 25.9473 17.7192 25.667C18.2389 25.4264 18.4495 25.2567 18.3493 25.1571Z",
    fill: "url(#paint19_linear_563_19809)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7696 20.0866L12.7097 20.1767C12.6491 20.2763 12.6191 20.386 12.6202 20.5067C12.6003 20.6663 12.64 20.8667 12.7401 21.1067L13.0101 21.5261C13.1097 21.6862 13.27 21.8565 13.4901 22.036C13.57 22.1163 13.7704 21.9364 14.0901 21.4966L14.5101 20.7767C13.9497 20.3368 13.5298 20.0866 13.2495 20.0267C13.129 20.0069 13.0095 20.0069 12.8896 20.0267L12.7696 20.0866Z",
    fill: "url(#paint20_linear_563_19809)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6497 13.0681C24.4302 11.3275 24.2903 10.2074 24.2298 9.70815C24.2099 9.42786 24.1001 9.16746 23.8999 8.9282C23.5999 8.58855 23.1794 8.43855 22.6399 8.4782C22.0999 8.51785 21.72 8.74833 21.4999 9.16825C21.38 9.42805 21.3302 9.71788 21.3499 10.0376C21.4104 10.6982 21.5802 11.8484 21.8604 13.4876L23.0905 21.2276C23.2302 22.2475 23.4204 23.4374 23.6604 24.7975C23.8997 25.9173 24.09 26.7272 24.2298 27.2276C24.7302 28.9081 25.1095 29.7776 25.3698 29.8376C25.5697 29.6983 25.6495 28.7677 25.6099 27.0481C25.6493 26.3077 25.6398 25.4983 25.5792 24.618L25.4898 21.0481L24.6497 13.0681Z",
    fill: "url(#paint21_linear_563_19809)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_563_19809",
    x1: 1.67832,
    y1: 63.4848,
    x2: 40.3558,
    y2: 49.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_563_19809",
    x1: 28.4924,
    y1: 37.3537,
    x2: 63.9775,
    y2: 24.6557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_563_19809",
    x1: 28.5846,
    y1: 35.3877,
    x2: 32.5863,
    y2: 30.6254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_563_19809",
    x1: 33.5106,
    y1: 31.7288,
    x2: 37.0618,
    y2: 30.1796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_563_19809",
    x1: 39.2642,
    y1: 28.836,
    x2: 43.8484,
    y2: 26.5947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_563_19809",
    x1: 45.7045,
    y1: 25.5932,
    x2: 48.5778,
    y2: 22.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_563_19809",
    x1: 33.4371,
    y1: 35.6141,
    x2: 37.5619,
    y2: 32.6782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_563_19809",
    x1: 42.0547,
    y1: 34.3253,
    x2: 44.0359,
    y2: 29.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_563_19809",
    x1: 48.5902,
    y1: 32.9606,
    x2: 52.1974,
    y2: 30.7316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_563_19809",
    x1: 55.2506,
    y1: 31.95,
    x2: 57.9016,
    y2: 28.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_563_19809",
    x1: 29.79,
    y1: 41.7118,
    x2: 32.8765,
    y2: 37.3067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_563_19809",
    x1: 34.6092,
    y1: 43.7163,
    x2: 37.7302,
    y2: 42.3296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_563_19809",
    x1: 39.2714,
    y1: 46.4425,
    x2: 41.5138,
    y2: 45.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_563_19809",
    x1: 29.6506,
    y1: 44.1086,
    x2: 43.3477,
    y2: 28.0932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_563_19809",
    x1: 26.8272,
    y1: 29.8529,
    x2: 30.4968,
    y2: 29.0444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_563_19809",
    x1: 30.1379,
    y1: 23.6829,
    x2: 34.6976,
    y2: 21.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_563_19809",
    x1: 32.384,
    y1: 17.1343,
    x2: 35.5018,
    y2: 16.3191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_563_19809",
    x1: 34.5998,
    y1: 11.3644,
    x2: 37.5419,
    y2: 10.7406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_563_19809",
    x1: 19.2909,
    y1: 31.5045,
    x2: 22.7916,
    y2: 30.5129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_563_19809",
    x1: 16.4404,
    y1: 26.9548,
    x2: 20.1043,
    y2: 23.9184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_563_19809",
    x1: 12.4921,
    y1: 22.6674,
    x2: 15.157,
    y2: 21.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_563_19809",
    x1: 21.067,
    y1: 36.2472,
    x2: 27.693,
    y2: 35.7847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounConfetti);
export default __webpack_public_path__ + "static/media/noun-confetti.a5523ef78d59fd94eaa1809cfc067a3c.svg";
export { ForwardRef as ReactComponent };